import * as React from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
   root: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
   }, 
   ul: {
      "& .Mui-selected": {
         backgroundColor: "#F9B233",
         color: "#fff !important"
      },
      "& .MuiPaginationItem-root": {
         color: "#000000ba"
      }
   },
   pagination: {
      "& ul, & li": {
         "&::before": {
            content: "none"
         }
      }
   }
}));

type Props = {
   count: number;
   onChange: (event: React.ChangeEvent<unknown>, value: any) => void;
   key?: any;
};

export default function PaginationMaterial({count, onChange, key}: Props) {
   const classes = useStyles();

   return (
      <div className={classes.pagination} key={key}>
         <Stack spacing={2}>
            <Pagination
               count={count}
               className={classes.ul}
               defaultValue={1}
               onChange={(e, value) => onChange(e, value)}
               renderItem={(item) => (
                  <PaginationItem
                     slots={{previous: ArrowBackIcon, next: ArrowForwardIcon}}
                     {...item}
                  />
               )}
            />
         </Stack>
      </div>
   );
}
